import { useMemo } from 'react'
import { ChartOptions } from 'chart.js'
import { getMarketPricesChartOptions } from 'components/charts/market-prices/chartjs.config.ts'
import { Chart } from 'react-chartjs-2'
import { MarketPricesChartProps } from './types.ts'

const MarketPricesChartMobile = ({ chartData, granularity, labels, setHoverDataPointIndex, isCompact }: MarketPricesChartProps) => {
  // Constants
  const options = useMemo<ChartOptions<'bar'>>(
    () => getMarketPricesChartOptions({ granularity, labels, handleHoverDataPoint: setHoverDataPointIndex, isMobile: true, isCompact }),
    [granularity, labels, setHoverDataPointIndex, isCompact]
  )

  return <Chart type="bar" options={options} data={chartData} />
}

export default MarketPricesChartMobile
